// extracted by mini-css-extract-plugin
module.exports = {"pagePlateInput":"plateInput_pagePlateInput__2yCFM"};